import { render, staticRenderFns } from "./PageInfo.vue?vue&type=template&id=e8238394&scoped=true"
import script from "./PageInfo.vue?vue&type=script&lang=js"
export * from "./PageInfo.vue?vue&type=script&lang=js"
import style0 from "./PageInfo.vue?vue&type=style&index=0&id=e8238394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8238394",
  null
  
)

export default component.exports